import { Box, Stack } from '@mui/material'
import Overview from "./Overview";
import Attendance from "./Attendance";
import LeaveCalendarView from './LeaveCalendarView';

function Dashboard() {
    return (
        <Box sx={{p: 0}}>
            <Stack spacing={0}>
                <Overview />
                <Attendance />
            </Stack>
            <LeaveCalendarView />
        </Box>
    );
}

export default Dashboard;